import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Circle } from "react-native-svg"

const SvgOthers = (props) => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={20} height={5} fill="none" viewBox="0 0 20 5" {...props}>
            <Circle cx={2.5} cy={2.5} r={2} stroke={baseColors.black} />
            <Circle cx={10} cy={2.5} r={2} stroke={baseColors.black} />
            <Circle cx={17.5} cy={2.5} r={2} stroke={baseColors.black} />
        </Svg>
    )
}

export default SvgOthers
